import React from 'react';
import {useOutletContext} from 'react-router-dom';
import ItemComments from '../components/ItemComments';
import {hasPermission, useWardrobe} from '../context/WardrobeContext';
import type {ItemPageContext} from './ClothingItemDetail';

const ItemCommentsTab: React.FC = () => {
    const {item, itemId, selectedOwnerId} = useOutletContext<ItemPageContext>();
    const {isOwnWardrobe, permissions} = useWardrobe();
    // Вещь в корзине/выбывшая комментариев больше не принимает (retired-item-actions-guard):
    // прежние комментарии остаются видимыми, форма скрыта — сервер такой запрос вернёт 409.
    const isFrozen = !!item.inTrashBin || !!item.thrownAway;
    const canAdd = (isOwnWardrobe || hasPermission(permissions, 'ADD_COMMENTS')) && !isFrozen;

    return (
        <ItemComments
            itemId={itemId}
            ownerId={selectedOwnerId}
            canAdd={canAdd}
            canDelete={isOwnWardrobe}
        />
    );
};

export default ItemCommentsTab;
